var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalcard = function SvgPersonalcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.625 34.125h-16.25c-6.5 0-8.125-1.625-8.125-8.125V13c0-6.5 1.625-8.125 8.125-8.125h16.25c6.5 0 8.125 1.625 8.125 8.125v13c0 6.5-1.625 8.125-8.125 8.125Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13h8.125M24.375 19.5h6.5M27.625 26h3.25M13.813 18.346a2.941 2.941 0 1 0 0-5.882 2.941 2.941 0 0 0 0 5.882ZM19.5 26.536a4.908 4.908 0 0 0-4.453-4.42 12.537 12.537 0 0 0-2.47 0c-2.356.227-4.225 2.064-4.452 4.42"
  }))));
};
export default SvgPersonalcard;